import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EnvironmentService } from './environment.service';
import { v4 as uuid } from 'uuid';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PersistenceService } from './persistence.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
    constructor(private environmentService:EnvironmentService, private router:Router, private http:HttpClient, private persistenceService:PersistenceService, private authService:AuthService) {}

    private _appId:string = null;

    private _refreshSessionTimeout = null;

    private _getSessionId() {
        clearTimeout(this._refreshSessionTimeout);
        this._refreshSessionTimeout = setTimeout(() => {
            this.sendEvent('IDLE')
        }, 5 * 60 * 1000)

        let _cSessionId:string = null;

        let _cSavedSessionString = this.persistenceService.getItem('POIGEST_AnalyticsSession');
        if(_cSavedSessionString != null) {
            try {
                let _cSavedSessionObj = JSON.parse(_cSavedSessionString)
                let _cDate = new Date(_cSavedSessionObj.time);

                if(Date.now() - _cDate.getTime() < 5.5 * 60 * 1000) { // IDLE è ogni 5 minuti e refresha la sessione, gli lascio un po' di margine per refreshare il token
                    _cSessionId = _cSavedSessionObj.id;
                }
            }
            catch(ex) {}
        }

        if(_cSessionId == null) {
            _cSessionId = uuid();

            console.log('AnalyticsService.getSessionId', _cSessionId)
        }

        this.persistenceService.setItem('POIGEST_AnalyticsSession', JSON.stringify({ id: _cSessionId, time: new Date().toISOString() }), 'analytics')

        return _cSessionId;
    }

    isInitialized = false;

    init(appId:string) {
        if(!this.isInitialized && this.persistenceService.hasConsentFor('analytics')) {
            this.isInitialized = true;

            this._appId = appId;

            let _domain:string = null;
            
            let _match = this.environmentService.environment.EntouranceAPIUrl.match(/api\.([^\.]*)\.entourance/)
            if(_match != null) {
                _domain = _match[1]
            }

            this.sendEvent('INIT', {
                appId: appId,
                //AppName: this.environmentService.environment.AppName,
                //AppMode: this.environmentService.environment.AppMode,
                domain: _domain,
                userAgent: navigator.userAgent || navigator.vendor,
                referrer: document.referrer
            })
    
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.sendEvent('ROUTE', event.urlAfterRedirects);
                }
            })

        }
    }

    sendEvent(event:string, params?:any) {
        if(this.isInitialized) {
            let _cSessionId = this._getSessionId();
            console.log('AnalyticsService.sendEvent', this._appId, _cSessionId, event, params)

            let _body = {
                "app_id": this._appId,
                "session_id": _cSessionId,
                "realm_id": null,
                "event": event,
                "params": params
            }
    
            this.http.post(this.environmentService.environment.EntouranceAPIUrl + '/public/analytics/event', _body, {
                headers: new HttpHeaders({ 'X-Interceptor-Silent': '*' })
            }).subscribe(() => {}, () => {})
        }
    }
}
